import { Model } from '@psyomics/surveyjs-core';
import React from 'react';
import { Survey } from 'survey-react-ui';

import { useExtendSurveyModel, registerComponents } from '../shared/customiser';

import 'survey-core/survey-core.css';
import '../shared/styles.scss';

type SurveyBuilderProps = {
  readonly model: Model;
};

registerComponents();

export const SurveyRenderer: React.FC<SurveyBuilderProps> = ({ model }) => {
  useExtendSurveyModel(model);
  return <Survey model={model} />;
};
